module.exports = __webpack_public_path__ + "img/fundo-contact.0cef8a2f.jpg";